<template>
  <div class="entry-txt"
       v-html="infoTxt"/>
  <div class="join-stage-con mgt10">
    <div class="join-stage-input">
      <input type="text" placeholder="성명" title="성명"
             maxlength="50"
             v-model="mberNm"/>
    </div>
    <div class="join-stage-input"
         v-if="tabSe == 'pswd'">
      <input type="text" placeholder="아이디" title="아이디"
             ref="id" maxlength="20"
             v-model="mberId"/>
    </div>
    <!-- 휴대폰번호로 찾기 -->
    <div class="join-stage-input">
      <div class="join-stage-box">
        <select v-model="mbpnTlno1"
                :disabled="isPrcdgCrtfc"
                @change="mbpnTlno_change">
          <option v-for="mbpn in $cmmn.txt.mbpns"
                  :key="mbpn"> {{ mbpn }}</option>
        </select>
        <input type="text" class="mgr10"
               maxlength="4"
               :disabled="isPrcdgCrtfc"
               @change="mbpnTlno_change"
               v-model="mbpnTlno2"/> -
        <input type="text" class="mgl10"
               maxlength="4"
               :disabled="isPrcdgCrtfc"
               @change="mbpnTlno_change"
               v-model="mbpnTlno3"/>
      </div>
      <button :class="!isPrcdgCrtfc && mbpnTlno.length >= 12 ? 'act':'deagi'"
              @click="btnCrtfc_click">
        <span>{{ isCrtfc? '재인증' : '인증'}}</span>
      </button>
    </div>
    <div class="join-stage-input">
      <input type="text" placeholder="인증번호 입력(3분 이내)"
             title="인증번호"
             :style="{'background': !isPrcdgCrtfc?'#f8f8f8':'#fff'}"
             maxlength="6"
             @keyup="$cmmn.number.only_keyup()"
             @keydown="$cmmn.number.only_keydown()"
             :disabled="!isPrcdgCrtfc"
             v-model="crtfcNo"/>
      <span class="time">{{ showTimeFormat }}</span>
      <button :class="crtfcNo.length == 6 && isPrcdgCrtfc? 'act':'deagi'"
              @click="btnCnfm_click">확인</button>
    </div>
  </div>
  <div class="layer-btn">
    <btn :txt="'취소'"
         :color="'white'"
         @click="btnCancl_click"/>
    <btn :txt="'다음'"
         :color="'purple'"
         @click="btnNext_click"/>
  </div>
</template>

<script setup>
import {computed, defineProps, ref, defineEmits, onUnmounted} from "vue";
import {getUtils, getStore} from "@/utils/import";
const {$cmmn, $alert, $axios} = getUtils();
const {$loading} = getStore();

const tabSe = computed(() => props.tabSe);
const props = defineProps({
  tabSe: {
    type: String,
    required: true
  }
})

const emits = defineEmits(['next', 'close']);
const infoTxt = computed(() => {
  let txt = '가입 시 등록한 <span class="pc01">성명과 ';
  if (tabSe.value == 'pswd') txt += '아이디, ';
  txt += '휴대폰번호</span>를 입력해주세요.';
  return txt;
});


const mberNm = ref('');
const mberId = ref('');
const crtfcNo = ref('');
const isCrtfc = ref(false);
const isPrcdgCrtfc = ref(false);
const mbpnTlno1 = ref('010');
const mbpnTlno2 = ref('');
const mbpnTlno3 = ref('');
const mbpnTlno = computed(() => mbpnTlno1.value + '-' + mbpnTlno2.value + '-' + mbpnTlno3.value);

const time = ref(0);
const timer = ref();
const showTimeFormat = computed(() => {
  let showTime = '--:--';

  if (timer.value) {
    const min = Math.floor(time.value / 60);
    let sec = time.value % 60;

    if (!min && !sec) showTime = '--:--';
    else {
      if (sec < 10) sec = '0' + sec;
      showTime = min + ':' + sec;
    }
  }

  return showTime;
});

const btnCrtfc_click = async () => {
  if (isPrcdgCrtfc.value) return false;

  try {
    $loading.on();

    if (mbpnTlno.value.length < 12) {
      return false;
    }

    await sendCrtfcNo();
    initTimer();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const sendCrtfcNo = async () => {
  isCrtfc.value = false;
  isPrcdgCrtfc.value = true;

  await $axios.post('/api/cmmn/sms/crtfc-no', {mbpnTlno: mbpnTlno.value, mberSn: 0});
  await $alert('인증번호를 발송했습니다. 인증번호가 오지 않으면</br> ' +
          '입력하신 정보가 정확한지 확인해주세요. </br>' +
          '발송된 인증번호는 3분간 유효합니다.');
}

const initTimer = () => {
  clearInterval(timer.value);

  time.value = 180;
  timer.value = setInterval(() => {
    if(time.value > 0) time.value -= 1;
    else {
      $alert('인증번호 유효시간이 만료되었습니다. 다시 인증해주세요.');
      isPrcdgCrtfc.value = false;
      clearInterval(timer.value);
    }
  }, 1000);
}

const btnCnfm_click = async () => {
  // 인증 중인 상태 + 인증번호 6자리 입력한 경우
  const isPsblCnfm = isPrcdgCrtfc.value && crtfcNo.value.length == 6;
  if (!isPsblCnfm) return false;

  try {
    $loading.on();

    await getIsCrtfcNo();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const getIsCrtfcNo = async () => {
  const {data} = await $axios.get('/api/cmmn/is-crtfc-no', {params: {crtfcNo: crtfcNo.value, mbpnTlno: mbpnTlno.value}})

  if (!data) {
    await $alert('인증번호가 일치하지 않습니다. 수신한 인증번호를 다시 한번 확인해주세요.');
    return false;
  }

  await $alert('인증번호가 일치합니다.');
  isCrtfc.value = data;
  isPrcdgCrtfc.value = false;
  clearInterval(timer.value);
}

const mbpnTlno_change = () => {
  isCrtfc.value = false;
}

const btnNext_click = async () => {
  const {isValid, msg} = valid();

  if (!isValid) {
    await $alert(msg)
    return false;
  }

  emits('next', {mberNm: mberNm.value, mberId: mberId.value, mbpnTlno: mbpnTlno.value});
}

const valid = () => {
  let isValid = true;
  let msg = '';

  const isInputMberNm = mberNm.value;
  if (isValid && !isInputMberNm) {
    isValid = false;
    msg = '성명을 입력해주세요.';
  }

  const isInputMberId = props.tabSe == 'pswd' && mberId.value == '';
  if (isValid && isInputMberId) {
    isValid = false;
    msg = '아이디를 입력해주세요.';
  }

  const isInputMbpnTlno = mbpnTlno.value.length >= 12;
  if (isValid && !isInputMbpnTlno) {
    isValid = false;
    msg = '핸드폰 번호를 입력해주세요.';
  }

  if (isValid && !isCrtfc.value) {
    isValid = false;
    msg = '핸드폰 인증을 해주세요.';
  }

  return {isValid, msg};
}

const btnCancl_click = () => {
  emits('close');
}

onUnmounted(() => {
  // 화면 닫을 시 타이머 종료
  clearInterval(timer.value);
})

</script>

<style scoped>
.time {position:absolute;right:3.5rem;width:77px;height:3.6rem;line-height:3.6rem;font-size:13px;}
</style>
